﻿import { MainSite } from "../../MainSite";
import { ParameterSets } from "../../Model/ClientConf/UserClientConf";
import { Chart } from "./Chart";
import { PlottingPage } from "./PlottingPage";

export class ChartCustomLimitsDialog {
    private _titleText: string = 'Message';

    private modal: JQuery = null;
    private modalContent: JQuery = null;
    private modalHeader: JQuery = null;
    private modalCloseButton: JQuery = null;
    private modalHeaderText: JQuery = null;
    private modalBody: JQuery = null;
    private modalFooter: JQuery = null;
    private modalFooterDismissButton: JQuery = null;

    private inputMinVal: JQuery = null;
    private inputMaxVal: JQuery = null;
    private inputMinCheck: JQuery = null;
    private inputMaxCheck: JQuery = null;


    constructor(private _mainsite: MainSite, private _plotting_page: PlottingPage, private _chart: Chart, private _axis: __Highcharts.AxisObject, private _axisIndex: number, private _axisId: string, private _custom_conf: ParameterSets.PlotAxisConfig) {
        this._titleText = "Set chart custom limits";
    };

    public show(): void {
        this.modal = $('<div class="modal fade"></div>').appendTo('body');
        this.modalContent = $('<div class="modal-content"></div>')
            .appendTo($('<div class="modal-dialog"></div>').appendTo(this.modal));

        this.modalHeader = $('<div class="modal-header"></div>').appendTo(this.modalContent);
        this.modalCloseButton = $('<button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>').appendTo(this.modalHeader);
        this.modalHeaderText = $('<h4 class="modal-title"></h4>').appendTo(this.modalHeader);
        this.modalHeaderText.text(this._titleText);
        this.modalBody = $('<div class="modal-body"></div>').appendTo(this.modalContent);

        //: build form:
        let $form: JQuery = $("<form>").addClass("form-horizontal").appendTo(this.modalBody);

        let $group: JQuery = null;
        let $check_label: JQuery = null;

        //: axis ID label:
        $group = $("<div>").addClass("form-group").appendTo($form);
        $("<label>").addClass("col-sm-2 control-label").text("Axis:").appendTo($group);
        $("<p>").addClass("form-control-static").text(this._axisId).appendTo($("<div class=\"col-sm-10\">").appendTo($group));

        let _current_extremes = this._axis.getExtremes();

        //: min:
        $group = $("<div>").addClass("form-group").appendTo($form);
        $("<label>").addClass("col-sm-2 control-label").text("Minimum:").appendTo($group);
        this.inputMinVal = $("<input type=\"text\" style=\"text-align:right;\" name=\"min\" placeholder=\"Minimum\">").addClass("input-sm form-control");
        this.inputMinVal.appendTo($("<div class=\"col-sm-5\">").appendTo($group));
        $check_label = $("<label>").addClass("checkbox inline").appendTo($("<div class=\"col-sm-5\">").appendTo($group));
        this.inputMinCheck = $("<input type=\"checkbox\" name=\"min_check\">").appendTo($check_label);
        $check_label.append("<span>Auto</span> <em class=\"text-muted\" style=\"font-weight:normal\">" + Math.floor(_current_extremes.dataMin) + "</em>");

        this.inputMinCheck.on("change", () => {
            if (this.inputMinCheck.is(":checked")) {
                this.inputMinVal.val(""); // .prop("disabled", true);
            } else {
                // this.inputMinVal.prop("disabled", false);
            }
        });

        this.inputMinVal.on("change", () => {
            if (this.inputMinVal.val() == "" || isNaN(this.inputMinVal.val())) {
                this.inputMinCheck.prop("checked", true).trigger("change");
            } else {
                this.inputMinCheck.prop("checked", false).trigger("change");
            }
        });

        //: max:
        $group = $("<div>").addClass("form-group").appendTo($form);
        $("<label>").addClass("col-sm-2 control-label").text("Maximum:").appendTo($group);
        this.inputMaxVal = $("<input type=\"text\" style=\"text-align:right;\" name=\"max\" placeholder=\"Maximum\">").addClass("input-sm form-control");
        this.inputMaxVal.appendTo($("<div class=\"col-sm-5\">").appendTo($group));
        $check_label = $("<label>").addClass("checkbox inline").appendTo($("<div class=\"col-sm-5\">").appendTo($group));
        this.inputMaxCheck = $("<input type=\"checkbox\" name=\"max_check\">").appendTo($check_label);
        $check_label.append("<span>Auto</span> <em class=\"text-muted\" style=\"font-weight:normal\">" + Math.ceil(_current_extremes.dataMax) + "</em>");

        this.inputMaxCheck.on("change", () => {
            if (this.inputMaxCheck.is(":checked")) {
                this.inputMaxVal.val(""); //.prop("disabled", true);
            } else {
                // this.inputMaxVal.prop("disabled", false);
            }
        });

        this.inputMaxVal.on("change", () => {
            if (this.inputMaxVal.val() == "" || isNaN(this.inputMaxVal.val())) {
                this.inputMaxCheck.prop("checked", true).trigger("change");
            } else {
                this.inputMaxCheck.prop("checked", false).trigger("change");
            }
        });

        //: set values of inputs:
        this.inputMinCheck.prop("checked", true).trigger("change");
        this.inputMaxCheck.prop("checked", true).trigger("change");
        if (this._custom_conf !== null && "min" in this._custom_conf && this._custom_conf.min !== null) {
            //this.inputMinCheck.prop("checked", false).trigger("change");
            this.inputMinVal.val((this._custom_conf.min).toString()).trigger("change");
        }
        if (this._custom_conf !== null && "max" in this._custom_conf && this._custom_conf.max !== null) {
            //this.inputMaxCheck.prop("checked", false).trigger("change");
            this.inputMaxVal.val((this._custom_conf.max).toString()).trigger("change");
        }

        $("<div>").addClass("alert alert-info").html("<strong>Note:</strong> Clicking <strong>Update</strong> below will apply the limits to the displayed charts.<br><br>To save these limits in your custom configurations in your account, please click on <strong>Save Set</strong> underneath the list of Parameter Sets.").css("marginBottom", 0).appendTo(this.modalBody);

        //: footer & buttons:
        this.modalFooter = $('<div class="modal-footer"></div>').appendTo(this.modalContent);
        this.modalFooterDismissButton = $('<button type="button" class="btn btn-default" data-dismiss="modal">CANCEL</button>').appendTo(this.modalFooter);

        $('<button type="button" class="btn btn-success">UPDATE</button>').prependTo(this.modalFooter).on("click", () => {
            this.save();
        });

        this.modal.modal('show');
    }

    private save(): void {
        //: apply to charts (immediate, saving to ParamSets is done separately by using the "Save Set" button!):
        let new_custom_settings: ParameterSets.PlotAxisConfig = {
            min: null,
            max: null
        };

        if (this.inputMinCheck.prop("checked") == false) {
            new_custom_settings.min = parseFloat(this.inputMinVal.val());
        }
        if (this.inputMaxCheck.prop("checked") == false) {
            new_custom_settings.max = parseFloat(this.inputMaxVal.val());
        }

        this._axis.update(new_custom_settings, true);

        let yAxis = this._chart.chart.yAxis[this._axisIndex];
        this._chart.applyAxisFeatures(yAxis, this._axisIndex, this._axisId);

        this._plotting_page.customLimitsByAxisLabel[this._axisId] = new_custom_settings; /// JSON.stringify(new_custom_settings);
        this._plotting_page.resetCustomLimits(this._plotting_page.customLimitsByAxisLabel); // this sets the limits in the plotting page instance, and they are retrieved at time of saving the ParamSets.

        this.modal.modal('hide');
    }
}

 